"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectedHTML = exports.ParametricHTML = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const ParametricHTML = ({ value, params, }) => {
    const applied = (value || "").replace(/{{(.*?)}}/g, (_, capture) => {
        return (params === null || params === void 0 ? void 0 : params[capture]) || "";
    });
    return react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: applied } });
};
exports.ParametricHTML = ParametricHTML;
const InjectedHTML = ({ value, params, elements, }) => {
    const [rawElements, setRawElements] = react_1.default.useState([]);
    const classNameSuffix = (0, react_1.useMemo)(() => {
        return `-${Math.random().toString(36).slice(2, 9)}`;
    }, []);
    (0, react_1.useEffect)(() => {
        const list = [];
        for (const key of Object.keys(elements)) {
            for (const element of document.querySelectorAll(`.${key}-${classNameSuffix}`)) {
                list.push([key, element]);
            }
        }
        setRawElements(list);
    }, [params, value]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.ParametricHTML, { value: value, params: Object.assign(Object.assign({}, params), Object.fromEntries(Object.keys(elements).map((key) => [
                key,
                `<div class="${key}-${classNameSuffix}"></div>`,
            ]))) }),
        rawElements.map(([key, rawElement]) => {
            return rawElement && (0, react_dom_1.createPortal)(elements[key], rawElement);
        })));
};
exports.InjectedHTML = InjectedHTML;
